export enum ATTACHMENT_STATES {
  NONE =  'NONE',
  PENDING =  'PENDING',
  ERROR =  'ERROR',
  SIZE_ERROR =  'SIZE_ERROR'
}

export enum ATTACHMENT_SIZE_LIMIT {
  DEFAULT = 25 * 1024 * 1024 // 25mb
}

